import { render, staticRenderFns } from "./menu-title.vue?vue&type=template&id=70376078&scoped=true&"
import script from "./menu-title.vue?vue&type=script&lang=js&"
export * from "./menu-title.vue?vue&type=script&lang=js&"
import style0 from "./menu-title.vue?vue&type=style&index=0&id=70376078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70376078",
  null
  
)

export default component.exports